"use client";

import { usePathname } from "next/navigation";
import React, { JSX, useEffect } from "react";
import IconClose from "@/app/(components)/generics/Icons/IconClose";
import { ModalStore } from "@/app/stores/ModalStore";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./Modal.module.css";

export enum ModalType {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
}

export default function Modal(): JSX.Element {
  const { isOpen, title, component, footer, type, closeWhenClickOutside, closeModal } =
    ModalStore();

  const pathname = usePathname();

  useEffect(() => {
    closeModal();
  }, [pathname, closeModal]);

  const handleModalClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!closeWhenClickOutside) {
      return;
    }

    if (event.target === event.currentTarget) {
      closeModal();
    }
  };

  const handleContentClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement;
    const paginationBtn = target.closest("button");
    const hasPaginationParent = target.closest('[class*="Pagination_"]');

    if (paginationBtn && hasPaginationParent) {
      const modalElement = document.getElementById("modal");
      if (modalElement) {
        modalElement.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  };

  const modalTypeClassName = (): string => {
    switch (type) {
      case ModalType.SMALL:
        return styles.small;
      case ModalType.MEDIUM:
        return styles.medium;
      case ModalType.LARGE:
        return styles.large;
    }

    return styles.small;
  };

  return (
    <div
      className={UStyles.classNames(styles.background, !isOpen ? styles.close : "")}
      onPointerDown={handleModalClick}
    >
      <div
        className={UStyles.classNames(
          styles.modal,
          modalTypeClassName(),
          isOpen ? styles.zoomIn : "",
        )}
        id="modal"
      >
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <button className={styles.closeButton} onClick={closeModal}>
            <IconClose />
          </button>
        </div>

        <div className={styles.content} onClick={handleContentClick}>
          {component}
        </div>

        <div className={styles.footer}>{footer}</div>
      </div>
    </div>
  );
}
